var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"id":"project-summary__content"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"10"}},[_c('balance-overview',{attrs:{"isBalance":_vm.isBalanceValue}})],1),_c('v-col',{attrs:{"cols":"2"}},[_c('selected-regions')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }